// extracted by mini-css-extract-plugin
export default {"wrapper":"ReCaptchaWithTitle__wrapper--2oK","title":"ReCaptchaWithTitle__title--1tM"};